<div class="inner-mat-dialog flex content-stretch items-stretch flex-col">
    <div><h1 mat-dialog-title>Create Acknowledgement - {{alert.asset.machineNo}} - {{alert.systemAlertType.name}} Alert</h1></div>
    <div class="flex-1 overflow-auto">
        <div class="ack-form">
            <mat-form-field appearance="outline">
                <mat-label>Acknowledgement Type</mat-label>
                <mat-select matInput required [(ngModel)]="ackType" placeholder="Select">
                    <mat-option value="Ok">Ok</mat-option>
                    <mat-option value="Maintenance">Maintenance</mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="ack-form">
            <mat-form-field appearance="outline">
                <mat-label>Acknowledgement Details</mat-label>
                <textarea matInput placeholder="Details (optional)..."
                [(ngModel)]="details"></textarea>
            </mat-form-field>
        </div>
    </div>
    <mat-dialog-actions class="flex justify-end content-end items-end w-full flex-row">
        <button mat-button class="btn-primary btn-done" (click)="onDoneClicked()">Done</button>
    </mat-dialog-actions>
    <mat-dialog-actions class="flex justify-end content-end items-end w-full flex-row">
        <button mat-button class="btn-default btn-done" (click)="onCancelClicked()">Cancel</button>
    </mat-dialog-actions>
</div>